import { LockRounded } from '@mui/icons-material';
import { IconButton, Tooltip } from '@mui/material';
import { LockOpenRoundedIcon } from 'app/icons';
import React, { forwardRef } from 'react';
const IconButtonComponent = forwardRef(function IconButtonComponent(props, ref) {
    return React.createElement("div", Object.assign({ ref: ref }, props));
});
export const GuardButton = ({ isLocked, disabled, onToggle, guardDisabled, tooltipTitle = 'Перейдите на последнее состояние', size = 'small', }) => {
    if (disabled && !onToggle) {
        return (React.createElement(IconButton, { size: size, disabled: true },
            React.createElement(LockRounded, { fontSize: size })));
    }
    const LockIcon = isLocked ? LockRounded : LockOpenRoundedIcon;
    const color = isLocked ? 'primary' : 'inherit';
    const title = guardDisabled ? tooltipTitle : '';
    return (React.createElement(Tooltip, { title: title, placement: 'top', disableInteractive: true, arrow: true },
        React.createElement(IconButtonComponent, null,
            React.createElement(IconButton, { size: size, color: color, disabled: disabled || guardDisabled, onClick: onToggle },
                React.createElement(LockIcon, { fontSize: size })))));
};
